import type { CustomerData } from './types';

export interface AddToCartCustomerPayload {
  email: string;
  phone: string;
  firstName?: string;
  lastName?: string;
}

export interface AddPaymentInfoCustomerPayload {
  email?: string;
  phone?: string;
  firstName?: string;
  lastName?: string;
  address1?: string;
  address2?: string;
  city?: string;
  state?: string;
  postalCode?: string;
  country?: string;
}

function hasValue(value?: string): value is string {
  return typeof value === 'string' && value.trim().length > 0;
}

/**
 * Mapeia CustomerDataStore para payloads de eventos de conversão.
 */
export class CustomerMapper {
  static toAddToCartCustomer(
    data: CustomerData
  ): AddToCartCustomerPayload | null {
    if (!hasValue(data.email) || !hasValue(data.phone)) return null;

    const customer: AddToCartCustomerPayload = {
      email: data.email.trim(),
      phone: data.phone.trim(),
    };

    if (hasValue(data.firstName)) customer.firstName = data.firstName.trim();
    if (hasValue(data.lastName)) customer.lastName = data.lastName.trim();

    return customer;
  }

  static toAddPaymentInfoCustomer(
    data: CustomerData
  ): AddPaymentInfoCustomerPayload | null {
    const customer: AddPaymentInfoCustomerPayload = {} as AddPaymentInfoCustomerPayload;

    if (hasValue(data.email)) customer.email = data.email.trim();
    if (hasValue(data.phone)) customer.phone = data.phone.trim();
    if (hasValue(data.firstName)) customer.firstName = data.firstName.trim();
    if (hasValue(data.lastName)) customer.lastName = data.lastName.trim();
    if (hasValue(data.address1)) customer.address1 = data.address1.trim();
    if (hasValue(data.address2)) customer.address2 = data.address2.trim();
    if (hasValue(data.city)) customer.city = data.city.trim();
    if (hasValue(data.state)) customer.state = data.state.trim();
    if (hasValue(data.postalCode))
      customer.postalCode = data.postalCode.trim();
    if (hasValue(data.country)) customer.country = data.country.trim();

    return Object.keys(customer).length > 0 ? customer : null;
  }
}
